module.exports = __webpack_public_path__ + "static/Angular-053955d4ec761209504c2b0ca1345dda.mp4";